import { transactionRoute } from "./transaction";

export const historyRoutes = [
  {
    path: "orders-history",
    name: "ordersHistory",
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.history.ordersHistory"
    },
    component: () =>
      import(
        /* webpackChunkName: "OrdersHistory" */ "@/views/panel/Market/ordersHistory/index"
      )
  },
  {
    path: "precondition-orders-history",
    name: "preconditionOrdersHistory",
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.history.preconditionOrdersHistory"
    },
    component: () =>
      import(
        /* webpackChunkName: "PreconditionOrdersHistory" */ "@/views/panel/Market/PreconditionOrdersHistory/index"
      )
  },
  {
    path: "p2p-transactions",
    name: "transactions",
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.history.transactions"
    },
    component: () =>
      import(
        /* webpackChunkName: "Transactions" */ "@/views/panel/Market/transactions/index"
      )
  },
  {
    path: "transaction",
    name: "transaction-order",
    redirect: `/history/transaction/deposits`,
    meta: {
      transitionName: "slide",
      appBarTitle: "pageTitles.transactionOrder.deposits"
    },
    component: () =>
      import(
        /* webpackChunkName: "transactionPage" */ "@/views/panel/TransactionsPage/index"
      ),
    children: transactionRoute
  }
];
